import { FC, useEffect, useState } from 'react'

import { Episode } from 'models'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import {
  Button,
  PlayIcon,
  PlayerDescription,
  PlayerTitle,
  VideoTileSlide,
} from './styled'

type Props = {
  episode: Episode
  isActive: boolean
}

export const VideoTile: FC<Props> = ({ episode, isActive }) => {
  const [isPlayerVisible, setPlayerVisible] = useState(false)
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  useEffect(() => {
    if (!isActive && isPlayerVisible) {
      setPlayerVisible(false)
    }
  }, [isActive, isPlayerVisible])

  return (
    <VideoTileSlide>
      {isPlayerVisible ? (
        <>
          {isMobile && (
            <Button as="span">
              <PlayerDescription>{episode.episode_about}</PlayerDescription>
            </Button>
          )}
          <iframe
            src={`https://www.youtube.com/embed/${episode.episode_yt_id
              .replace('https://youtu.be/', '')
              .trim()}?autoplay=1`}
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            title={episode.episode_title}
          />
        </>
      ) : (
        <>
          <img src={episode.episode_cover} alt={episode.episode_title} />
          <Button onClick={() => setPlayerVisible(true)}>
            <PlayIcon />
            <PlayerTitle>{episode.episode_title}</PlayerTitle>
            <PlayerDescription>{episode.episode_about}</PlayerDescription>
          </Button>
        </>
      )}
    </VideoTileSlide>
  )
}
